import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { format } from 'date-fns';

const postsPerPage = 6;

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const NoticiasListar = ({ noticias }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const pageFromUrl = parseInt(searchParams.get('page')) || 1;
  const [currentPage, setCurrentPage] = useState(pageFromUrl);

  useEffect(() => {
    setCurrentPage(pageFromUrl);
  }, [pageFromUrl]);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = noticias.slice(indexOfFirstPost, indexOfLastPost);

  const totalPages = Math.ceil(noticias.length / postsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setSearchParams({ page: pageNumber });
      scrollToTop();
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else {
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      pageNumbers.push(1);

      if (startPage > 2) pageNumbers.push('...');

      for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

      if (endPage < totalPages - 1) pageNumbers.push('...');

      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <div className="container">
      <div className="row g-4">
        {currentPosts.map((post) => (
          <div className="col-lg-4 col-md-6 gallery-item" key={post.id}>
            <div className="de-item">
              <Link to={`/noticia/${post.url}`} state={{ from: location.pathname + location.search }}>
                <img src={post.foto} className="img-fluid" alt={post.titulo} />
              </Link>
            </div>

            <div className="post-text">
              <div className="d-date">
                {post.data_publicacao &&
                  format(new Date(post.data_publicacao), 'dd/MM/yyyy')}
              </div>
              <h4>
                <Link to={`/noticia/${post.url}`} state={{ from: location.pathname + location.search }}>{post.titulo}</Link>
              </h4>
              <p className="previa">{post.previa}</p>
            </div>
          </div>
        ))}

        {/* PAGINAÇÃO */}
        <div className="col-md-12">
          <ul className="pagination">
            <li className={currentPage === 1 ? 'disabled' : ''}>
              <button onClick={() => paginate(currentPage - 1)}>Anterior</button>
            </li>

            {renderPageNumbers().map((page, index) =>
              page === '...' ? (
                <li key={index} className="disabled"><span>...</span></li>
              ) : (
                <li key={index} className={currentPage === page ? 'active' : ''}>
                  <button onClick={() => paginate(page)}>{page}</button>
                </li>
              )
            )}

            <li className={currentPage === totalPages ? 'disabled' : ''}>
              <button onClick={() => paginate(currentPage + 1)}>Próxima</button>
            </li>
          </ul>
        </div>
        
      </div>
    </div>
  );
};

export default NoticiasListar;
